<template>
    <v-dialog v-model="showDialog" width="1200px">
        <v-card>
            <v-card-title class="justify-center">Approve/decline changes for {{ entity }} {{ entity_key }}<v-spacer></v-spacer><btn_component type="text" :text="item.openText" color="primary" tooltip="open in a new window" size="x-small" :data="true"  @actionClick="openItem" v-if="item.openText !==''"/></v-card-title>  
            <v-divider></v-divider>
            <v-card-text>{{ item.description }}</v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table 
                    :items="items" 
                    :items-per-page="10" 
                    :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                    :headers="headers">
                    <!-- :search="search">  -->
                    <template v-slot:item="props">
                        <tr>
                            <td><v-simple-checkbox v-model="props.item.wzvz_selected" hideDetails :id="props.item.wzvz_encrid" :value="props.item.wzvz_encrid" class="checkSmall pb-2" @input="changeSelection()" v-if="props.item.wzvz_change_allowed&&props.item.wzvz_type==='Automatic'"/></td>
                            <td>{{ props.item.wzvz_gebr_afh_type }}</td>
                            <!-- <td>{{ props.item.wzvz_gebr_code_aanm }}</td> -->
                            <td>{{ props.item.wzvz_veldnaam }}</td>
                            <td><longTextView :long_text="props.item.wzvz_veldwaarde_oud" :max_width="200"/></td>
                            <td><longTextView :long_text="props.item.wzvz_veldwaarde_nieuw" :max_width="200"/></td>
                            <td><longTextView :long_text="props.item.wzvz_opm" :max_width="150"/></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            
            <v-divider></v-divider>
            <v-textarea class="pa-4" v-model="remark" label="remark" rows="2"></v-textarea>
            <v-divider></v-divider>

            <v-divider></v-divider>
            <v-card-actions>
                <btn_component type="text" text="Select all"     color="primary" tooltip="Select all changes"              size="x-small" :data="true"  @actionClick="selectAll"/>
                <btn_component type="text" text="Clear"          color="primary" tooltip="Clear selection"                 size="x-small" :data="false" @actionClick="selectAll"/>
                <btn_component type="text" text="Save remark"    color="primary" tooltip="Save remark to selected changes" size="x-small"  data=""      @actionClick="saveRemarkWzvz"/>
                <v-spacer></v-spacer>
                <btn_component type="avatar_icon"        color="green"   tooltip="Approve selected changes" icon="mdi-check-circle-outline" :disabled="remark.length<5" :data="true"  @actionClick="approveDeclineWzvzSelectedRemark"/>
                <btn_component type="avatar_icon"        color="red"     tooltip="Decline selected changes" icon="mdi-close-circle-outline" :disabled="remark.length<5" :data="false" @actionClick="approveDeclineWzvzSelectedRemark"/>
                <btn_component type="text" text="Cancel" color="primary" tooltip="Cancel approve/decline"   size="x-small"                                               data=""      @actionClick="closeDialog"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import longTextView from "@/components/ui/fields/longTextView.vue";
    
    export default {
        components: {
            btn_component,
            longTextView,
        },    
        data() {
            return {
                showDialog: false,
                remark: "",
                remark_keep: "",
                entity: "",
                entity_key: "",
                items: [],
                item: {
                    description: "",
                    openItemLink: ""
                },
                selected: [],
                headers: [
                    { text: "", width: "3%" },
                    { text: "Department", value: "wzvz_gebr_afh_type", width: "7%" },
                    // { text: "Requestor", value: "wzvz_gebr_code_aanm", width: "7%" },
                    { text: "Field", value: "wzvz_veldnaam", width: "15%" },
                    { text: "Current Value", value: "wzvz_veldwaarde_oud", width: "15%"  },
                    { text: "Pending Value", value: "wzvz_veldwaarde_nieuw", width: "15%"  },
                    { text: "Remark", value: "wzvz_opm", width: "15%"  },
                ],
            }
        },  
        methods: {  
            openDialog(entity, entity_key) {
                this.remark = "";
                this.remark_keep = "";
                this.entity = entity;
                this.entity_key = entity_key;
                this.listWzvzDetails();
            },
            openItem() {
                window.open(this.item.openItemLink, "_blank");
            },
            listWzvzDetails() {
                this.$axios.post("ares/json/ares/wzvz/listWzvzDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "listWzvzDetails"
                    },
                    listWzvzDetails: {
                        entity: this.entity,
                        entity_key: this.entity_key,
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.item = res.data.listWzvzDetails.item;
                        this.items = res.data.listWzvzDetails.list;
                        this.remark = res.data.listWzvzDetails.remark;
                        this.remark_keep = res.data.listWzvzDetails.remark;
                        this.selected = [];
                        // this.changeSelection();
                        this.showDialog = true;
                    }
                });
            },
            approveDeclineWzvzSelectedRemark(approve) {
                if (this.selected.length === 0) {
                    this.noSelection();
                    return;
                }
                this.$emit("approveDeclineWzvz", this.selected, approve, this.remark);
                this.closeDialog();
            },
            selectAll(newValue) {
                this.selected = [];
                for (let i=0; i<this.items.length; i++) {
                    if (this.items[i].wzvz_change_allowed&&this.items[i].wzvz_type==="Automatic") {
                        this.items[i].wzvz_selected = newValue;
                        if (newValue) {
                            this.selected.push(this.items[i].wzvz_encrid);
                        }
                    }
                }
                this.changeSelection();
            },
            changeSelection() {
                this.selected = [];
                for (let i=0; i<this.items.length; i++) {
                    if (this.items[i].wzvz_selected) {
                        this.selected.push(this.items[i].wzvz_encrid);
                    }
                }
                // this.$emit("updateSelection", this.selected); 
            },
            saveRemarkWzvz() {
                if (this.selected.length === 0) {
                    this.noSelection();
                    return;
                }
                this.$emit("saveRemarkWzvz", this.selected, this.remark, this.remark_keep)
            },
            closeDialog() {
                this.showDialog = false;
            },
            noSelection() {
                this.$store.dispatch("setSnackbar", {
                    showing: true,
                    text: "There are no changes selected",
                    color: "warning",
                });
            },
        }
    }
</script>

<style scoped> 

</style>